// Tailwind's default breakpoints plus the overrides of `theme.extend.screens` in tailwind.config.ts: keep both in sync.
// Sorted widest first so the first match is the active breakpoint.
const BREAKPOINTS: Array<{ name: string; minWidth: number }> = [
  { name: '4xl', minWidth: 2200 },
  { name: '3xl', minWidth: 1800 },
  { name: '2xl', minWidth: 1400 },
  { name: 'xl', minWidth: 1280 },
  { name: 'lg', minWidth: 1024 },
  { name: 'md', minWidth: 768 },
  { name: 'sm', minWidth: 640 },
]

export const viewportBreakpoint = (width: number): string => BREAKPOINTS.find((breakpoint) => width >= breakpoint.minWidth)?.name ?? 'base'
